import { ChakraProvider, Text } from '@chakra-ui/react';
import { CUIAutoComplete } from 'chakra-ui-autocomplete'
import { Input } from 'components/Input';
import { Visible } from 'components/Visible';
import { useState } from 'react';

export type Option = {
    label: string;
    value: string;
}

type AutocompleteProps = {
    placeholder?: string;
    label?: string;
    onChange: (items: Option[]) => void;
    onInputChange: () => void;
    options: Option[];
}

const Autocomplete = ({label, placeholder, onChange, onInputChange, options}: AutocompleteProps) => {
    const [selectedItem, setSelectedItem] = useState<Option[]>([]);

    const onHandleChange = (item: Option[]) => {
        setSelectedItem(item);
        onChange(item);
    };

    return (
        <>
        <Visible when={selectedItem.length === 0}>
            <ChakraProvider>
                <CUIAutoComplete
                    inputStyleProps={{
                        marginTop: -3
                    }}
                    labelStyleProps={{
                        display: 'none'
                    }}
                    tagStyleProps={{
                        display: 'none',
                    }}
                    itemRenderer={(item) => <Text> {item.label}</Text>}
                    highlightItemBg=""
                    disableCreateItem
                    renderCustomInput={(inputProps) => <Input
                        placeholder={placeholder} variant='filled' onChange={onInputChange}  {...inputProps} />}
                    hideToggleButton
                    label={label || ''}
                    placeholder={placeholder || ''}
                    items={options}
                    onSelectedItemsChange={(changes) => onHandleChange(changes.selectedItems || [])}
                />
            </ChakraProvider>
      </Visible>
      <Visible when={selectedItem.length !== 0}>
        <Input variant='filled' defaultValue={selectedItem[0]?.label} onChange={() => setSelectedItem([])} />
    </Visible>
      </>
    );
}

export {Autocomplete};